import '../scss/styles.scss';
import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
import Vue from 'vue/dist/vue.js';
import multiselect from "./multiselect";
import dropzone from './dropzone';

//import flash from './flash';
Vue.config.devtools = false;
Vue.config.productionTip = false;


if (document.getElementById("formOuter")) {
    window.VueRoot = new Vue({
	    el: '#formOuter',
	    components: {
	        'vue-dropzone': dropzone,
	        'vue-multiselect': multiselect,
	    //       'flash': flash,
	    }
    });
}
